import type { TruckStatus } from "@/constants/truck";

export enum ReportType {
  payments = "payments",
  orders = "orders",
  unitsByHr = "units-by-hr",
}

export enum ExpirationType {
  licenceExpire = "licence_expire",
  driverLicenseExpire = "driver_license_expire",
  companyInsuranceExpire = "company_insurance_expire",
}

export type ExpirationRowDto = {
  type: ExpirationType;
  truckId: number;
  truckNumber: string;
  truckStatus: TruckStatus;
  ownerId: number;
  ownerName: string;
  ownerCompanyName: string;
  driverId: number | null;
  driverName: string;
  expireDate: string;
};
